import AbstractNetworkStatus from '../all/AbstractNetworkStatus';
import logger from 'src/utils/logger/logger';

class NetrangeNetworkStatus extends AbstractNetworkStatus {
  constructor() {
    super();
  }

  isOnline() {
    logger.debug('[NetworkStatus] checking Netrange...');
    return this.onlineByAjax();
  }
}

export default NetrangeNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/netrange/NetworkStatus.js